import axios from '@axios'

export const state = {
  settings: null,
  status: null,
  loading: false,
  error: null,
}

export const getters = {
  settings: (state) => state.settings,
  status: (state) => state.status,
  loading: (state) => state.loading,
  error: (state) => state.error,
}

export const mutations = {
  SET_SETTINGS: (state, settings) => {
    state.settings = settings
  },

  SET_STATUS: (state, status) => {
    state.status = status
  },

  SET_LOADING: (state, loading) => {
    state.loading = loading
  },

  SET_ERROR: (state, error) => {
    state.error = error
  },
}

export const actions = {
  async getSettings({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/api/auto-credit-topup/settings')
      if (response.status === 200) {
        commit('SET_SETTINGS', response.data)
        commit('SET_ERROR', null)
      }
      return response
    } catch (error) {
      commit(
        'SET_ERROR',
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
          'Failed to load settings'
      )
      commit('SET_SETTINGS', null)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async saveSettings({ commit }, settings) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.post(
        '/api/auto-credit-topup/settings',
        settings
      )
      if (response.status === 200) {
        commit('SET_SETTINGS', response.data)
        commit('SET_ERROR', null)
      }
      return response
    } catch (error) {
      commit(
        'SET_ERROR',
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
          'Failed to save settings'
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getStatus({ commit }) {
    try {
      const response = await axios.get('/api/auto-credit-topup/status')
      if (response.status === 200) {
        commit('SET_STATUS', response.data)
      }
      return response
    } catch (error) {
      commit(
        'SET_ERROR',
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
          'Failed to load status'
      )
      throw error
    }
  },

  async runTopupNow({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.post('/api/auto-credit-topup/run-now')
      if (response.status === 200) {
        commit('SET_ERROR', null)
      }
      return response
    } catch (error) {
      commit(
        'SET_ERROR',
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
          'Failed to run topup'
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
}
